// Avoid Chrome DevTools blue warning.
export function getPlatform() {
  if (typeof navigator === 'undefined') {
    return '';
  }
  const uaData = navigator.userAgentData;
  if (uaData?.platform) {
    return uaData.platform;
  }
  return navigator.platform;
}
export function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) {
    return false;
  }
  return CSS.supports('-webkit-backdrop-filter:none');
}
export function isIOS() {
  return /iP(hone|ad|od)|iOS/.test(getPlatform());
}